import { render, staticRenderFns } from "./HelpContent.vue?vue&type=template&id=64401967&scoped=true"
import script from "./HelpContent.vue?vue&type=script&lang=js"
export * from "./HelpContent.vue?vue&type=script&lang=js"
import style0 from "./HelpContent.vue?vue&type=style&index=0&id=64401967&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64401967",
  null
  
)

export default component.exports